<template>
  <div
    :class="[
      'BaseDropdown',
      { dropped },
      { matchWidth },
      ('BaseDropdown-anchor-' + anchor),
      { persistLabel },
    ]">
    <div
      class="BaseDropdown_label"
      ref="BaseDropdownLabel"
      @click.prevent.stop="toggleDropdown">
      <slot
        name="label">
        <i
          :class="[
            'BaseDropdown_icon',
            computedIcon,
          ]">
        </i>
      </slot>
    </div>

    <div
      class="BaseDropdown_dropdown"
      :style="computedDropdownStyle">
      <slot
        name="dropdown">
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseDropdown',

  data() {
    return {
      dropped: false,
      paddingTop: 0,
    };
  },

  props: {
    icon:         { type: String,  default: 'dropdown' },
    matchWidth:   { type: Boolean, default: false },
    anchor:       { type: String,  default: 'left' },
    persistLabel: { type: Boolean, default: true },
    offsetTop:    { type: Number,  default: 0 },
    offsetRight:  { type: Number,  default: 0 },
    offsetLeft:   { type: Number,  default: 0 },
  },

  computed: {
    computedIcon() {
      return `icon-${this.icon}`;
    },

    computedDropdownStyle() {
      return {
        paddingTop: `${this.paddingTop}px`,
        top: `${this.offsetTop}px`,
        right: (this.anchor === 'left') ? 'auto' : `${this.offsetRight}px`,
        left: (this.anchor === 'right') ? 'auto' : `${this.offsetLeft}px`,
      };
    },
  },

  mounted() {
    // Hub.$on('document-click', this.closeDropdown);

    this.$nextTick(() => {
      this.paddingTop = this.persistLabel
        ? this.$refs.BaseDropdownLabel.offsetHeight
        : 0;
    });
  },

  methods: {
    closeDropdown() {
      this.dropped = false;
    },

    openDropdown() {
      this.dropped = true;
      this.$emit('open');
    },

    toggleDropdown() {
      if (this.dropped) return this.closeDropdown();
      return this.openDropdown();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.BaseDropdown {
  position: relative;
}

.BaseDropdown_label {
  position: relative;
}

.BaseDropdown_icon {
  font-size: 18px;
}

.BaseDropdown_dropdown {
  visibility: hidden;
  position: absolute;
  top: 0;
  left: 0;
  border: $border;
  border-radius: $radius;
  background-color: $white;
  box-shadow: 0 2px 16px rgba($black, .2);
}

.BaseDropdown-anchor-right .BaseDropdown_dropdown {
  right: 0;
  left: auto;
}

.BaseDropdown.dropped {
  .BaseDropdown_dropdown {
    visibility: visible;
    z-index: 2;
  }
}

.BaseDropdown.dropped.persistLabel .BaseDropdown_label {
  z-index: 3;
}

.BaseDropdown.matchWidth {
  .BaseDropdown_dropdown {
    min-width: 100%;
  }
}
</style>
